import { UNAUTH_USER } from '../../actions/auth';

/**
 * Always check if current action is unauth and remove state.
 *
 * @param reducer {Function} Reducer.
 * @returns {Function}
 */
export default function resetOnLogout(reducer) {
  return function(state, action) {
    if (action.type === UNAUTH_USER) {
      state = undefined;
    }

    return reducer(state, action);
  };
}
